import React, { useState } from 'react'
import styled from '@emotion/styled'
import { get } from 'lodash-es'
import CreateField from './createField'
import FieldsEditor from './fieldEditor'
import FieldsList from './fieldList'
import dittoEditor from '../ditto/register.editor'

const EditorBox = styled.div`
  background: #e5e7eb;
  .fields-list,
  .create-field {
    flex: 1;
    background: #fff;
    margin-right: 10px;
  }
  .fields-editor {
    flex: 2;
    background: #fff;
  }

  .split-line {
    width: 1px;
    background: #dcdcdc;
  }
`

/**
 * 字段编辑绑定组件
 * @param {array} fieldList 字段列表
 * @param {string} bindTip 控制是否置灰绑定图标显示绑定提示
 * @param {number} currentBindIndex 当前绑定索引
 * @param {array} createFieldFilter 设置新建的文件类型
 * @param {object} onBindFuns 绑定解绑相关方法
 * @param {function} onChangeOrder 当变更排序时
 * @param {function} onDragStart 当变更排序开始时
 * @param {function} onCreateField 点击新建字段时执行的函数
 * @param {function} onDeleteField 点击删除字段时执行的函数
 * @param {function} onSaveField 点击保存字段时执行的函数
 * @param {function} onChangeType 点击修改类型字段时执行的函数
 * @param {function} onInfoDirty 表单编辑了内容后执行的函数
 * @returns
 */
const EditorPage = ({
  fieldList,
  bindTip,
  currentBindIndex,
  createFieldFilter,
  onBindFuns,
  onChangeOrder,
  onDragStart,
  onCreateField,
  onDeleteField,
  onSaveField,
  onChangeType,
  onInfoDirty,
}) => {
  const [curFieldIndex, setCurFieldIndex] = useState()
  const [showCreatePage, setShowCreatePage] = useState(false)

  const onChangeFieldIndex = (index) => {
    setCurFieldIndex(index)
  }

  const onClickField = (e, i) => {
    setCurFieldIndex(i)
  }

  /**
   * 创建一个新 slug 标识
   * @param {object} field 当前需判重的字段对象
   * @param {string} url type类型所在的属性地址（ lodash 的 get 属性）
   * @returns 一个新的slug字符串
   */
  const getNewSlug = (field, url = 'config.type') => {
    let newSlug = get(field, url, '') + '-' + Date.now()
    if (fieldList.find((e) => e.slug === newSlug)) {
      newSlug = getNewSlug(field)
    }
    return newSlug
  }

  return (
    <EditorBox className="h-full w-full flex">
      {showCreatePage ? (
        <CreateField
          className="create-field"
          onCloseCreatePage={() => {
            setShowCreatePage(false)
          }}
          createFieldFilter={createFieldFilter}
          setShowCreatePage={setShowCreatePage}
          onCreateField={(field) => {
            const newField = get(field, 'config', null)
              ? {
                  ...field.config,
                  slug: getNewSlug(field),
                }
              : []
            onCreateField(newField, onChangeFieldIndex)
            setShowCreatePage(false)
          }}
        />
      ) : (
        <FieldsList
          className="fields-list"
          fieldList={fieldList}
          bindTip={bindTip}
          onChangeOrder={(list, startIndex, endIndex) => {
            onChangeOrder(list, startIndex, endIndex, onChangeFieldIndex)
          }}
          onDragStart={onDragStart}
          currentBindIndex={currentBindIndex}
          curFieldIndex={curFieldIndex}
          onClickField={onClickField}
          onOpenCreatePage={() => {
            setShowCreatePage(true)
          }}
          onBindFuns={onBindFuns}
        />
      )}
      <div className="split-line" />
      <FieldsEditor
        className="fields-editor"
        fieldList={fieldList}
        curFieldIndex={curFieldIndex}
        createFieldFilter={createFieldFilter}
        onDeleteField={(field) => {
          onDeleteField(field, curFieldIndex, onChangeFieldIndex)
        }}
        onSaveField={(field) => {
          onSaveField(field, curFieldIndex)
        }}
        onChangeType={(typeItem) => {
          const field = dittoEditor.config(typeItem.type)
          const newField = {
            ...field,
            slug: getNewSlug(field, 'type'),
          }
          onChangeType(newField, curFieldIndex)
        }}
        onInfoDirty={onInfoDirty}
      />
    </EditorBox>
  )
}

export default EditorPage
